export default {"src":"/_next/static/media/residential-land-icon-selected.67c55c79.svg","height":88,"width":111,"blurWidth":0,"blurHeight":0};